export default __webpack_public_path__ + "static/media/sales-management.5646ec08.jpeg";